import {useLocation} from "@khan/urls";

// sync-start:tool-persona 555602282 https://github.com/Khan/webapp/blob/master/libs/khanmigo/tools/src/types.ts
enum ToolPersona {
    Teacher = "TEACHER",
    Parent = "PARENT",
    Admin = "ADMIN",
}
// sync-end:tool-persona

export function useAIGuideToolPersona(): ToolPersona {
    const {pathname} = useLocation();

    return pathname.includes("district")
        ? ToolPersona.Admin
        : pathname.includes("parent")
          ? ToolPersona.Parent
          : ToolPersona.Teacher;
}
